import * as React from "react";
import { useContext } from "react";
import { FormComponentProps } from "antd/lib/form";
import { Row } from "antd";
import { AuthContext } from "src/components/context/AuthContext";
import "./CommissionSliderComponent.scss";
import { SliderComponent } from '../SliderComponent/SliderComponent';

interface ICommissionSliderComponent {
  minCommission: number;
  maxCommission: number;
  commission: number;
  minPrice: number;
  maxPrice: number;
  price: number;
  handleChangeValue: (price: number, commission: number, changeType: 'price' | 'commission') => void;
  needToPrecifyPercentLender: boolean;
  canEditQuotePrice: boolean;
}

export function CommissionSliderComponent(props: ICommissionSliderComponent & FormComponentProps) {
  const { currentUser } = useContext(AuthContext);

  return (
    <>
      {props.canEditQuotePrice && (
        <>
          <Row>
            <SliderComponent
              form={props.form}
              handleChange={commissionValue => {
                const price = ((commissionValue - props.minCommission) * (props.minPrice - props.maxPrice)) / (props.maxCommission - props.minCommission) + props.maxPrice
                props.handleChangeValue(price, commissionValue, "commission")
              }}
              value={props.commission}
              maxValue={props.maxCommission}
              minValue={props.minCommission}
              needToPrecifyPercentLender={props.needToPrecifyPercentLender}
              title="Comissão R$"
              isVisible={currentUser.permissions.userCanSeeCommission}
              fieldName="commission"
            />
          </Row>

          <Row>
            <SliderComponent
              form={props.form}
              handleChange={price => {
                const commissionValue = ((price - props.minPrice) * (props.minCommission - props.maxCommission)) / (props.maxPrice - props.minPrice) + props.maxCommission
                props.handleChangeValue(price, commissionValue, "price")
              }}
              value={props.price}
              maxValue={props.maxPrice}
              minValue={props.minPrice}
              needToPrecifyPercentLender={props.needToPrecifyPercentLender}
              title="Preço"
              isVisible={currentUser.permissions.userCanSeeCommission}
              fieldName="price"
            />
          </Row>
        </>
      )}
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/PricingComponents/CommissionSliderComponent/CommissionSliderComponent.tsx